module.exports = __webpack_public_path__ + "static/media/cae_white.9d2881cf.svg";